import { fromEvent, merge, Observable } from 'rxjs';
import { Component, Input, ElementRef, ViewChildren, SimpleChanges } from '@angular/core';
import { FormControlName } from '@angular/forms';
import { ProjectItemWithSelectionComponent } from "./project-item-withselection.component";
import { GenericValidator } from '../shared/generic-validator';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';

@Component({
    selector: 'project-status',
    standalone: false,
    templateUrl: 'project-status.component.html',
    styleUrls: ['./project-status.component.css']
})
export class ProjectStatusComponent extends ProjectItemWithSelectionComponent {
    private validationMessages: { [key: string]: { [key: string]: string } };
    private genericValidator: GenericValidator;
    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
    displayMessage: { [key: string]: string } = {};

    statusOptions: string[] = ['', 'NEW', 'PERMISSIBLE', 'CLEAR', 'PENDING', 'NOT_CLEAR', 'ABANDONED'];
    selectedStatus: string = '';

    @Input('department')
    public department: string = '';

    constructor() {
        super();
        this.validationMessages = {
            sortOrder: {
                pattern: 'Please enter a valid number.'
            },
            statusName: {
                duplicateStatus: 'A status with this name already exists in the department.',
                duplicateStatusInProject: 'A status with this name already exists in the project.'
            }
        }
        this.genericValidator = new GenericValidator(this.validationMessages);
    }

    ngAfterViewInit() {
        let controlBlurs: Observable<any>[] = this.formInputElements
            .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));

        merge(this.projectItemForm.valueChanges, ...controlBlurs).pipe(
            debounceTime(500)
        ).subscribe(value => {
            this.displayMessage = this.genericValidator.processMessages(this.projectItemForm);
        });

        this.projectItemForm.get('sortOrder')!.valueChanges.subscribe(value => {
            if (value === '') {
                this.projectItemForm.get('sortOrder')!.setValue(null, { emitEvent: false });
            }
        });

        this.setGroups();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['department']) {
            this.department = changes['department'].currentValue;
            this.setGroups();
        }
    }

    setGroups() {
        if (this.department === 'Features') {
            this.statusOptions = ['', 'NEW', 'PERMISSIBLE', 'CLEAR', 'PENDING', 'NOT_CLEAR', 'ABANDONED'];
        } else {
            this.statusOptions = ['', 'NEW', 'CLEAR', 'PENDING', 'NOT_CLEAR', 'ABANDONED'];
        }
    }
}
